import React from 'react';

import HeroSection from './components/HeroSection';
import RequestForm from './components/RequestForm';
import ChatWidget from './components/ChatWidget';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <RequestForm />
      <ChatWidget />
    </div>
  );
};

export default Home; 